import React from 'react';
//import { Button } from 'semantic-ui-react';
//import { Segment } from 'semantic-ui-react';
//import PropTypes from 'prop-types';
//import { Container, Divider } from 'semantic-ui-react';

import { connect } from 'react-redux';
import {UserActions} from '../actions';
import {PanelTop} from './PanelPages';



class Login extends React.Component {
    constructor(props) {
        super(props);

        //this.props.dispatch(UserActions.logout());
        this.state = {
            email: '',
            password: '',
            submitted:false
        };
        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    handleChange(event) {
        this.setState({
            [event.target.id]: event.target.value
        });
    }

    onSubmit(e) {
        e.preventDefault();
        const { dispatch } = this.props;
        const { email, password } = this.state;
        this.setState({ submitted: true });
        
        if (email && password) {
            
            dispatch(UserActions.login(this.state.email, this.state.password));

        }
    }
    render() {
        const { email, password, submitted } = this.state;
        const { loggingIn } = this.props;
        return (
            <div className = 'home-page'>
                <form onSubmit={this.onSubmit}>
                    <div className = {loggingIn ? 'App-overlay': null}>
                        <div class = "ui basic segment" style = {{padding: 0 }}>
                            {loggingIn &&
                    <div className="ui visible loader" />
                            }
                            <div>
                                <PanelTop>
                        
                                    <h1 id='login'>Login</h1>
                        
                                </PanelTop>
                                <div class="App-login-container">
                                    <div class="ui left icon input" style={{ width: '80%'}}>
                                        <input type="text"  placeholder="User Name*" id='email' onChange={this.handleChange} />
                                        <i class="user icon"></i>

                                    </div>
                                    <div class="ui left icon input" style={{ width: '80%' }}>
                                        <br/>
                                        <input type="password" placeholder="Password*" id='password' onChange={this.handleChange} />
                                        <i class="lock icon"></i>
                                    </div>
                                    <div>
                                        <button class="ui grey submit button" >Login</button>
                           
                                        {!email && submitted &&
                                <div className="App-help-block">Username is required</div>
                                        }
                                        {!password && submitted &&
                                <a className="App-help-block">Passsword is required</a>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }


}
function mapStateToProps(state) {
    const { loggingIn } = state.authentication;
    return {
        loggingIn
    };
}

const connectedLoginPage = connect(mapStateToProps)(Login);
export { connectedLoginPage as Login }; 







// WEBPACK FOOTER //
// ./src/components/Login.jsx